import React from 'react';
import { PATIENT_SEARCH_COLUMNS } from './subparts/patientFilesQuery';
import PatientFilesIcon from './subparts/PatientFilesIcon';
import { PATIENT_TOOLBAR_CHIP_THEMES } from './subparts/patientFilesListTheme';

function PatientFilesToolbar({
    isLoading,
    searchTerm,
    searchColumn,
    showAll,
    onClearSearch,
}) {
    const searchColumnLabel = PATIENT_SEARCH_COLUMNS.find((item) => item.value === searchColumn)?.label;
    const searchColumnTheme = PATIENT_SEARCH_COLUMNS.find((item) => item.value === searchColumn)?.theme;
    const hasReset = Boolean(searchTerm?.trim() || showAll);

    if (!hasReset && !showAll) {
        return null;
    }

    return (
        <div className="patient-files-toolbar">
            <div className="patient-files-toolbar__meta">
                {searchTerm?.trim() && !showAll && (
                    <span className="patient-files-chip">
                        <PatientFilesIcon
                            icon="bi-funnel"
                            theme={searchColumnTheme || PATIENT_TOOLBAR_CHIP_THEMES.filter}
                            size="xs"
                        />
                        {searchColumnLabel}: &quot;{searchTerm.trim()}&quot;
                    </span>
                )}
                {showAll && (
                    <span className="patient-files-chip">
                        <PatientFilesIcon
                            icon="bi-collection"
                            theme={PATIENT_TOOLBAR_CHIP_THEMES.all}
                            size="xs"
                        />
                        All active patients
                    </span>
                )}
            </div>

            {hasReset && (
                <div className="patient-files-toolbar__controls">
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary ecx-modal__close-btn"
                        onClick={onClearSearch}
                        disabled={isLoading}
                    >
                        <i className="bi bi-x-lg me-1" />
                        Reset
                    </button>
                </div>
            )}
        </div>
    );
}

export default PatientFilesToolbar;
